'use strict';

import axios from 'axios';
import { listenDOMEvent } from '@jspartials/dom-api-utils';
import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';
import { gtmLaunchCustomerSignUpSuccessfully } from '@jspartials/gtm-utils';

// Selectors
const selector = {
  fastSignUp: {
    defaultContent: '.js-fast-sign-up__default-content',
    successContent: '.js-fast-sign-up__success-content',
    errorContent: '.js-fast-sign-up__error-content',
    form: '.js-fast-sign-up__form',
    submitButton: '.js-fast-sign-up__submit-button'
  }
};

// Elements
const element = {
  fastSignUp: {
    defaultContent:
      document.querySelector(selector.fastSignUp.defaultContent) || null,
    successContent:
      document.querySelector(selector.fastSignUp.successContent) || null,
    errorContent:
      document.querySelector(selector.fastSignUp.errorContent) || null,
    form: document.querySelector(selector.fastSignUp.form) || null,
    submitButton:
      document.querySelector(selector.fastSignUp.submitButton) || null
  }
};

// Functions

/**
 * Handle fast sign up form submit
 * @param {Event} event - Event
 * @returns {void}
 */
const handleFastSignupFormSubmit = (event) => {
  event.preventDefault();

  const url = element.fastSignUp.form.getAttribute('action');
  const data = new FormData(element.fastSignUp.form);

  addClassToElement(element.fastSignUp.submitButton, classes.is.loading);
  addClassToElement(element.fastSignUp.errorContent, classes.hidden);

  axios
    .post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((response) => {
      const responseData = response.data;
      const error = 'error' in responseData ? responseData.error : false;
      const success = 'success' in responseData ? responseData.success : false;
      const hashedEmail =
        'hashedEmail' in responseData ? responseData.hashedEmail : '';

      if (error) {
        removeClassToElement(element.fastSignUp.errorContent, classes.hidden);
      }

      if (success) {
        addClassToElement(element.fastSignUp.defaultContent, classes.hidden);
        removeClassToElement(element.fastSignUp.successContent, classes.hidden);
        gtmLaunchCustomerSignUpSuccessfully({
          place: 'thank-you-page',
          hashedEmail: hashedEmail
        });
      }
    })
    .catch(() => {
      removeClassToElement(element.fastSignUp.errorContent, classes.hidden);
    })
    .then(() => {
      removeClassToElement(element.fastSignUp.submitButton, classes.is.loading);
    });
};

/**
 * Initialize sign up form
 * @returns {void}
 */
const initSignUpForm = () => {
  if (
    element.fastSignUp.defaultContent &&
    element.fastSignUp.successContent &&
    element.fastSignUp.errorContent &&
    element.fastSignUp.form &&
    element.fastSignUp.submitButton
  ) {
    listenDOMEvent(
      element.fastSignUp.form,
      'submit',
      handleFastSignupFormSubmit
    );
  } else {
    console.warn('Fast sign up form elements not found');
  }
};

export { initSignUpForm };
